import { yupResolver } from "@hookform/resolvers/yup";
import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import useTranslation from "next-translate/useTranslation";
import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { isEmpty } from "../../../utils/isEmpty";
import MolhamButton from "../MolhamButton";
import CommentController from "./CommentController";
import { TComment } from "apiTypes";
import { API_URL, AUTH_URL, NEXT_URL_PROXY } from "config";
import { postData } from "utils/postData";
import { toast } from "react-toastify";
type Props = {
  handleClose: () => void;
  showAddEditCommentModal: boolean;
  content?: TComment | null;
  mutate?: any;
  isAdd?: boolean;
};
const AddCommentReplyModal = ({
  handleClose,
  showAddEditCommentModal,
  mutate,
  content,
  isAdd,
}: Props) => {
  const { t } = useTranslation("common");
  const [isLoading, setIsLoading] = useState(false);
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        comment: Yup.string()
          .trim()
          .min(10, t(`comment_min_invalid`))
          .max(250, t(`comment_max_invalid`))
          .required(t(`field_required`)),
      }),
    [t]
  );
  const {
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
    control,
    watch,
  } = useForm<{
    comment: string;
  }>({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });
  const onEditCommentSubmit = async ({ comment }) => {
    const url = `${NEXT_URL_PROXY}/comments/${content.id}/replies`;

    try {
      setIsLoading(true);

      await toast.promise(
        postData(url, {
          content: comment,
        }),
        {
          pending: t(`loading`),
          success: `${t(`comment_edited`)}`,
          error: "Error when fetching",
        }
      );

      await mutate();
      handleClose();
      setIsLoading(false);
    } catch (err) {
      if (err?.response?.data.status === "Unauthorized") {
        toast.error(err.response.data.status);
        setIsLoading(false);
        return;
      }

      toast.error(err?.message);
      toast.error(err.response?.data.error?.code);
      setIsLoading(false);
    }
  };
  const onSubmit = async (data) => {
    try {
      await onEditCommentSubmit(data);
      reset();
    } catch (err) {}
  };

  return (
    <MolhamModalOffcanvas show={showAddEditCommentModal} onHide={handleClose}>
      <div className="mb-3">{content?.content}</div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={`needs-validation ${!isEmpty(errors) ? "invalid" : ""}`}
      >
        <CommentController
          control={control}
          name="comment"
          watch={watch}
          placeholder={t("write_reply_here")}
        />
        <MolhamButton
          id={`comment-${isAdd ? "add" : "edit"}-btn}`}
          disabled={!isDirty || !isValid}
          label={isAdd ? t(`add_reply`) : t(`edit_comment`)}
          isLoading={isLoading}
          className="w-100 mb-3 mb-lg-0"
          startIcon={isAdd ? "fe-plus fs-xl" : "fe-edit fs-xl"}
        />
      </form>
    </MolhamModalOffcanvas>
  );
};

export default AddCommentReplyModal;
